import {Component, OnInit} from '@angular/core';
import {LocalStorageService} from 'ngx-webstorage';
import {Router} from '@angular/router';
import {Location} from '@angular/common';


@Component({
  selector: 'app-subheader',
  templateUrl: 'subheader.component.html',
  styleUrls: ['subheader.component.scss'],
})
export class subHeaderComponent implements OnInit {

  heading;
  showButton: false;
  backButton = {title: '', link: ''};
  public showSubHeaderInPages = ['/about', '/how-to-order', '/faq'];

  constructor(private localSt: LocalStorageService,
              protected router: Router,
              protected location: Location) {
  }

  ngOnInit() {
    this.localSt.retrieve('subHeaderHeading') ? this.heading = this.localSt.retrieve('subHeaderHeading') : this.heading = '';
    if (this.localSt.retrieve('backButton')) {
      this.backButton = {
        title: this.localSt.retrieve('backButton').title,
        link: this.localSt.retrieve('backButton').link
      };
      this.showButton = this.localSt.retrieve('backButton').show;
    }
    this.localSt.observe('subHeaderHeading').subscribe((data) => {
      data ? this.heading = data : this.heading = '';
    });
    this.localSt.observe('backButton').subscribe((data) => {
      if (data) {
        this.backButton = {
          title: data.title,
          link: data.link
        };
        this.showButton = data.show;
      }
    });
  }

  backClick() {
    this.router.navigate([this.backButton.link]);
    this.localSt.store('hideSearchBar', '1');
  }

  public isHidden() {
    const path = this.location.path();
    return !(this.showSubHeaderInPages.indexOf(path) > -1);
  }
}



// WEBPACK FOOTER //
// ./src/app/template/subheader/subheader.component.ts